import { format } from 'date-fns';
import { ActivityLogEventType } from '../../models/ActivityLog';

const CONTENT_DIFF_EVENT_TYPES: ActivityLogEventType[] = [
  'CONTENT_DRAFT_SAVED',
  'CONTENT_PUBLISHED',
  'CONTENT_REVERTED',
  'CONTENT_AI_GENERATED',
  'CONTENT_AI_REFINED',
  'ARTICLE_AI_GENERATED',
  'ARTICLE_AI_REFINED',
  'ARTICLE_PUBLISHED',
];

export function isContentDiffEvent(eventType: ActivityLogEventType): boolean {
  return CONTENT_DIFF_EVENT_TYPES.includes(eventType);
}

export function formatActivityLogTimestamp(timestamp: string): string {
  try {
    return format(new Date(timestamp), 'MMM dd, yyyy HH:mm');
  } catch {
    return timestamp;
  }
}
